import { Const } from '../lib/const.cls'

export const getters = {
	
    //GET_USER_WATCH_LISTING
    [Const.GET_USER_WATCH_LISTING]: (state) => {
        return state.USER_WATCH_LIST
    },
    // GET_CATEGORIES_LISTING
    [Const.GET_CATEGORIES_LISTING]: (state) => {
        return state.CATEGORIES
    },
    // GET_ARTICELS_LISTING
    [Const.GET_ARTICELS_LISTING]: (state) => {
        return state.ARTICELS
    },
    [Const.GET_COMPLAINTS_DATA]: (state) => {
        return state.COMPLAINTS
    }

}



// WEBPACK FOOTER //
// ./src/plugins/finView/provider/candle-history/store-addons/getters.js